import React from 'react';
import Iconography, {
  IconographySizes,
} from '@hid-galaxy-ui/galaxy-react/components/Iconography';

import { RequirementIconId } from '../../constants/imageRules';

const REQUIREMENT_ICON_MAP: Record<RequirementIconId, string> = {
  'single-face': 'imagePortrait',
  'face-visible': 'circleUser',
  'eyes-open': 'eye',
  'no-sunglasses': 'eyeSlash',
  'no-caps': 'shieldBlank',
  'no-masks': 'shieldCheck',
  'no-occlusion': 'ban',
  background: 'image',
  'sharp-photo': 'circleCamera',
  lighting: 'brightness',
  contrast: 'plusMinus',
  jpeg: 'file',
  png: 'image',
  'file-size': 'file',
};

export const getRequirementIcon = (
  iconId: RequirementIconId,
  options?: { className?: string },
): JSX.Element => {
  const icon = REQUIREMENT_ICON_MAP[iconId];
  return (
    <Iconography
      icon={icon}
      size={IconographySizes.Small}
      className={options?.className}
    />
  );
};

export default getRequirementIcon;
